import React, { useState } from 'react'
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import Button from '../../../components/button/Button'
import LinkedButton from '../../../components/linkedButton/LinkedButton'
import { Link } from 'react-router-dom'

const TeamSection = () => {

    const [hoveredIndex, setHoveredIndex] = useState(0);

    const teamData = [
        {
            backgroundColor: '#94534d',
            text: "Punk with brown background is Muhammad Faiq Khokhar, a Senior Dev with expertise in Web Development, Web3 & Blockchain",
            imgUrl: "/assets/images/punk-1.webp"
        },
        {
            backgroundColor: '#8d6db5',
            text: "Punk with purple background is Eman Amir, a Senior Dev with expertise in Web Development",
            imgUrl: "/assets/images/punk-2.webp"
        },
        {
            backgroundColor: '#94534d',
            text: "Punk with brown background is Arslan Naveed, a Senior Dev with expertise in Mobile App Development",
            imgUrl: "/assets/images/punk-3.webp"
        },
        {
            backgroundColor: '#628494',
            text: "Punk with sea green background is Malik Ali Hassan, a Senior Dev with expertise in Unity ( Game Development )",
            imgUrl: "/assets/images/punk-4.webp"
        }
    ];

    return (
        <div className='bg-dull-black rounded-[48px] h-full w-full items-center flex flex-col gap-32 py-20'>
            <div className='flex lg:flex-row flex-col w-[90%] gap-10 lg:gap-20'>
                <div className='lg:w-[50%] text-center lg:text-left'>
                    <StyledH6Heading fontColor="text-gradient">Meet The Punks</StyledH6Heading>
                </div>
                <div className='lg:w-[50%] flex flex-col gap-10'>
                    <div>
                        <StyledMdText fontColor="text-white">Our team is dedicated to revolutionizing crowdfunding through blockchain technology.</StyledMdText>
                    </div>
                    <div className='flex gap-5'>
                        <Link to="/projects" className='w-[50%] lg:w-[40%]'>
                            <Button variant="button-gradient" fontColor="text-black">Donate Now</Button>
                        </Link>
                        <div className='w-[50%] lg:w-[40%]'>
                            <LinkedButton link="/projects" fontColor="text-white">View All Projects</LinkedButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col lg:flex-row items-center  lg:w-[90%] gap-20'>
                <div className='lg:w-[50%] flex flex-col items-center lg:items-start gap-3'>
                    {teamData.map((item, index) => (
                        <div
                            key={index}
                            className={`w-[90%] lg:w-full p-6 border border-white hover:bg-[${item.backgroundColor}] hover:border-[${item.backgroundColor}] rounded-3xl`}
                            onMouseEnter={() => setHoveredIndex(index)}
                            style={{
                                backgroundColor: hoveredIndex === index ? item.backgroundColor : '',
                                borderColor: hoveredIndex === index ? item.backgroundColor : ''
                            }}
                        >
                            <StyledMdText fontColor="text-white">{item.text}</StyledMdText>
                        </div>
                    ))}
                </div>
                <div className='w-[90%] lg:w-[50%] flex justify-center'>
                    {hoveredIndex !== null && (
                        <img width={500} height={200} src={teamData[hoveredIndex].imgUrl} alt={`Punk#${hoveredIndex + 1}`} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default TeamSection
